import React from "react";
import MyActivitiesTable from "./MyActivitiesTable";
const MyActivities = () => {
  return (
    <div className="bg-blue-body w-full h-full">
      <MyActivitiesTable />
    </div>
  );
};

export default MyActivities;
